export enum PushNotificationTypeEnum {
  None = 0,
  Mobile = 1,
  Telegram = 2,
  Mail = 4,
}
